export default __webpack_public_path__ + "assets/869cae.webp";